import { render, staticRenderFns } from "./reisetermin-view-detail-header-compact.vue?vue&type=template&id=04b0d719&scoped=true"
import script from "./reisetermin-view-detail-header-compact.vue?vue&type=script&lang=js"
export * from "./reisetermin-view-detail-header-compact.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-view-detail-header-compact.vue?vue&type=style&index=0&id=04b0d719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0d719",
  null
  
)

export default component.exports